export const en = {
  search_by_video: 'Search by Videos title',
  search_by_video_link: 'Search by Videos link',
  search_by_hashtag: 'Search by Hashtag',
  video_title: 'video title',
  published_on: 'published on',
  trending_on: 'trending on',
  trashed_on: 'trashed on',
  analyzed_influencer: 'analyzed influencer',
  analyzed_entity: 'analyzed entity',
  video: 'video',
  videos: 'videos',
  add_video: 'add video',
  video_url: 'video url',
  video_link: 'video link',
  invalid_video_url: 'the url link must be a youtube video',
  video_added: 'Video  Added Successfully, Go To ',
  video_exist: 'Video Already Exist In The System, Go To ',
  video_exists_incomplete:
    'This video exists in the system before as incomplete',
  details_page: 'details page',
  gain: 'gain',
  view: 'views',
  comment: 'comment',
  like: 'like',
  dislike: 'dislike',
  engagement: 'engagement',
  working_on_grabbing:
    'Working on grabbing your video, will be notified once finished',
  are_you_want_to_grabbing_the_data: 'are you want to grab the video data',
  num_of_views: 'number of views',
  total_videos: 'total videos',
  total_entities: 'total entities/influencers',
  video_platform: 'video/platform',
  trending_videos: 'trending videos',
  most_viewed_videos: 'most viewed videos',
  recent_videos: 'recent videos',
  top_used_hashtags: 'top used hashtags',
  entity: 'entity/influencer',
  compare_videos: 'compare videos',
  entities_details: 'entity details',
  influencer_details: 'influencer details',
  uploaded_videos: 'uploaded videos',
  upload: 'Upload',
  influencer_name: 'influencer name',
  entity_name: 'entity name',
  joined: 'joined',
  country: 'country',
  total_num_view: 'total number of views',
  channel_likes_dislikes: 'channel likes vs. dislikes',
  influencer_trust: 'entity/influencer trust',
  influencer_views: 'entity/influencer views',
  related_entities: 'related entities',
  related_channels: 'related channels',
  related_influencers: 'related influencers',
  related_hashtags: 'related hashtags',
  latest_update: 'latest update',
  entity_name: 'entity name',
  subscribers: 'subscribers',
  videos_table: 'videos table',
  platform: 'platform',
  channel_total_views: 'channel total views',
  added_on: 'added on',
  added_by: 'added by',
  followers: 'followers',
  name: 'name',
  related_tags: 'related tags',
  Speech_to_text: 'Speech to text',
  video_title: 'video title',
  trending_list: 'trending list',
  duplicate_link:
    'This video exists in the system before ,  click here to show details  ',
  published_date: 'published date',
  channel_activity: 'Channel Activity',
  expiredvideowarning: 'sorry,  video is not available on youtube',
  channel_total_subs: 'Channel Total Subscribers',
  total_subs: 'Total Subscribers',
  channel_views: 'Channel Views',
  this_video_trashed: 'This Video is trashed, Do you want to restore it?',
};

export const ar = {
  this_video_trashed: 'هذا الفيديو تم حذفه ، هل تريد استعادته؟',
  channel_activity: 'نشاط القناة ',
  published_date: 'تاريخ النشر',
  trending_list: 'قائمة الترندات',
  video_title: 'عنوان الفيديو',
  Speech_to_text: 'خطاب إلى نص',
  related_tags: 'الوسوم ذات صلة',
  channel_total_views: 'إجمالي عدد المشاهدات للقناة',
  search_by_video: 'بحث بإسم الفيديو',
  search_by_video_link: 'بحث برابط الفيديو',
  search_by_hashtag: 'بحث بإسم الهاشتاق',
  video_title: 'عنوان الفيديو',
  published_on: 'تم النشر في',
  trending_on: 'ترند في',
  trashed_on: 'تم الحذف في',
  analyzed_influencer: 'المؤثر الذي تم تحليله',
  analyzed_entity: 'الكيان الذي تم تحليله',
  video: 'الفيديو',
  videos: 'الفيديوهات',
  add_video: 'إضافة فيديو',
  video_url: ' أضف رابط الفيديو ',
  video_link: 'رابط الفيديو',
  invalid_video_url: 'الرابط يجب ان يكون رابط يوتيوب',
  video_added: 'تمت إضافة الفيديو بنجاح، اذهب إلى ',
  video_exist: 'الفيديو موجود في النظام مسبقا، اذهب إلى ',
  video_exists_incomplete: 'الفيديو تم اضافته من قبل على أنه غير مكتمل',
  details_page: 'صفحة التفاصيل',
  are_you_want_to_grabbing_the_data: 'هل انت متأكد انك تريد جلب بيانات الفيديو',
  num_of_views: 'عدد المشاهدات',
  total_videos: 'إجمالي الفيديوهات',
  total_entities: 'إجمالي الكيانات / المؤثرين',
  video_platform: 'الفيديو / المنصة',
  trending_videos: ' الفيديوهات الترند',
  most_viewed_videos: 'الفيديوهات الأكثر مشاهدة',
  recent_videos: 'الفيديوهات الحديثة',
  top_used_hashtags: 'الهاشتاقات الأكثر إستخداماً',
  entity: 'الكيان/المؤثر',
  compare_videos: ' مقارنة الفيديوهات',
  entities_details: ' تفاصيل الكيان ',
  influencer_details: 'تفاصيل المؤثر',
  uploaded_videos: 'مقاطع الفيديو المُحمّلة',
  upload: 'تم رفع',
  influencer_name: 'اسم المؤثر',
  entity_name: 'اسم الكيان ',
  joined: 'انضم ',
  country: 'الدولة',
  total_num_view: 'عدد المشاهدات الإجمالي',
  channel_likes_dislikes: ' معجب x غير معجب بالقناه  ',
  influencer_views: 'مشاهدات المؤثر/الكيان',
  related_entities: 'الكيانات ذات الصلة',
  related_channels: 'القنوات ذات الصلة ',
  related_influencers: 'المؤثرون ذو الصلة',
  related_hashtags: 'الهاشتاقات ذات الصلة',
  latest_update: 'اخر تحديث',
  entity_name: 'اسم الكيان',
  subscribers: 'المشتركين',
  videos_table: 'جدول الفيديوهات',
  platform: 'المنصة',
  view: 'مشاهدة',
  comment: 'تعليق',
  gain: 'حصد',
  like: 'اعجاب',
  dislike: 'عدم اعجاب',
  engagement: 'تفاعل',
  added_on: 'تمت الإضافة في',
  added_by: 'تمت الإضافة بواسطه',
  followers: 'المُتابِعون',
  name: 'الاسم',
  duplicate_link: ' الفيديو تم اضافته من قبل ، انقر هنا لعرض التفاصيل : ',
  expiredvideowarning: 'اسف ،هذا الفيديو غير متاح على اليوتيوب',
  channel_total_subs: 'اجمالى مشتركو القناة',
  total_subs: 'اجمالى المشتركين',
  channel_views: 'عدد المشاهدات القناة',
};
